// src/contexts/PageContext.js
import { createContext, useState, useEffect } from 'react';
import postData from '../resources/index.json';
import palette from '../palette.json';


const getRandomColorIndex = () => {
    return Math.floor(Math.random() * palette.length)
}

export interface Post {
    title: string;
    date: string;
    filename: string;
    tags: string[];
    draft?: boolean;
}

interface ContextParams {
    posts: Post[];
    colorIndex: number;
    randomizeColor: () => void;
}

export const AppContext = createContext<ContextParams>({ posts: [], colorIndex: 0, randomizeColor: () => { } });

export const ContextProvider = ({ children }) => {
    const [posts, setPosts] = useState<Post[]>([]);
    const [colorIndex, setColorIndex] = useState(getRandomColorIndex())

    useEffect(() => {
        setPosts(postData.posts.filter(p => !p.draft));
        randomizeColor();
    }, []);

    const randomizeColor = () => {
        setColorIndex(getRandomColorIndex())
    }

    return (
        <AppContext.Provider value={{ posts, colorIndex, randomizeColor }}>
            {children}
        </AppContext.Provider>
    );
};
